module.exports = __webpack_public_path__ + "img/questions-read-now.a283a8e5.svg";